var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrawberry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368B4C"
    },
    d: "M279.004,146.236c-5.798,1.909-12.039,3.569-18.755,4.952c0,0-3.714-8.944-6.056-22.799 c-5.199-30.794-3.621-85.883,60.618-121.03c3.838-2.094,7.902-4.127,12.194-6.076c8.346-3.786,18.074,1.176,19.972,10.141 c0.825,3.92,1.64,8.418,2.311,13.349C354.22,61.735,350.341,122.757,279.004,146.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3FA45A"
    },
    d: "M254.194,128.389c-5.199-30.794-3.621-85.883,60.618-121.03c0.155,0.97,0.299,1.96,0.433,2.971 C319.95,45.632,316.628,102.867,254.194,128.389z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368B4C"
    },
    d: "M218.596,178.325c-2.411,0-4.788-1.123-6.297-3.234l-74.44-104.011 c-2.487-3.475-1.687-8.308,1.788-10.795c3.473-2.485,8.308-1.688,10.795,1.789l74.44,104.011c2.487,3.476,1.687,8.308-1.788,10.795 C221.729,177.856,220.155,178.325,218.596,178.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368B4C"
    },
    d: "M187.334,203.377c-51.901,88.39-128.84,55.718-160.263,37.004 c-7.871-4.694-9.429-15.495-3.157-22.17c5.272-5.612,10.543-10.564,15.794-14.907c63.466-52.572,123.826-17.342,142.055-4.25 C185.374,201.656,187.334,203.377,187.334,203.377z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3FA45A"
    },
    d: "M181.763,199.056c-49.662,50.498-110.982,23.831-138.186,7.624c-1.537-0.918-2.837-2.063-3.869-3.373 C103.174,150.733,163.535,185.963,181.763,199.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CBA68"
    },
    d: "M226.206,183.427c-84.82,57.554-140.291-4.983-160.634-35.385 c-5.096-7.613-1.857-18.033,6.675-21.375c6.448-2.527,12.668-4.56,18.662-6.159c70.543-18.858,109.961,22.809,126.271,47.073 C223.338,176.741,226.206,183.427,226.206,183.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64C37D"
    },
    d: "M217.179,167.581c-63.517,24.161-106.67-19.756-126.271-47.073 C161.451,101.65,200.869,143.317,217.179,167.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CBA68"
    },
    d: "M229.403,181.607c81.623-62.005,40.07-134.538,17.754-163.525 c-5.588-7.261-16.496-7.517-22.387-0.499c-4.454,5.304-8.365,10.549-11.795,15.719c-40.393,60.83-13.493,111.489,4.294,134.691 C223.984,176.754,229.403,181.607,229.403,181.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64C37D"
    },
    d: "M217.269,167.993c43.176-52.479,15.336-107.394-4.294-134.691 C172.581,94.131,199.482,144.79,217.269,167.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C70024"
    },
    d: "M470.144,464.585c-1.124,3.074-2.435,6.025-3.931,8.862c-13.329,25.316-40.718,40.677-69.841,38.315 c-112.169-9.13-213.485-80.745-213.485-80.745c-80.735-53.583-90.762-169.919-19.075-221.222l2.445-1.743l52.334-37.469 l54.779-39.202c71.688-51.303,178.76-4.343,203.241,89.411C505.519,331.444,487.898,416.006,470.144,464.585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF0C38"
    },
    d: "M470.144,464.585c-1.124,3.074-2.435,6.025-3.931,8.862c-11.884,6.283-25.574,9.285-39.666,8.14 c-112.169-9.13-213.485-80.745-213.485-80.745c-68.077-45.185-85.883-134.978-46.805-192.79l52.334-37.469l54.779-39.202 c71.688-51.303,178.76-4.343,203.241,89.411C505.519,331.444,487.898,416.006,470.144,464.585z"
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8132 0.582 -0.582 -0.8132 526.838 498.8702)",
    cx: 183.356,
    cy: 333.987,
    rx: 9.295,
    ry: 16.738
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8132 0.582 -0.582 -0.8132 538.8193 324.1964)",
    cx: 217.38,
    cy: 248.573,
    rx: 9.295,
    ry: 16.738
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8132 0.582 -0.582 -0.8132 722.3733 375.006)",
    cx: 301.002,
    cy: 303.436,
    rx: 9.295,
    ry: 16.738
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8132 0.582 -0.582 -0.8132 864.5719 75.591)",
    cx: 420.154,
    cy: 176.55,
    rx: 9.295,
    ry: 16.738
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8132 0.582 -0.582 -0.8132 879.0467 277.8047)",
    cx: 394.939,
    cy: 279.98,
    rx: 9.295,
    ry: 16.738
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8132 0.582 -0.582 -0.8132 1024.7843 405.507)",
    cx: 447.313,
    cy: 367.22,
    rx: 9.295,
    ry: 16.738
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8132 0.582 -0.582 -0.8132 843.8409 556.6713)",
    cx: 332.581,
    cy: 413.763,
    rx: 9.295,
    ry: 16.738
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8132 0.582 -0.582 -0.8132 1015.0623 588.0151)",
    cx: 413.161,
    cy: 456.914,
    rx: 9.295,
    ry: 16.738
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8132 0.582 -0.582 -0.8132 691.648 157.5447)",
    cx: 320.54,
    cy: 189.774,
    rx: 9.295,
    ry: 16.738
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8132 0.582 -0.582 -0.8132 652.3148 619.9487)",
    cx: 226.662,
    cy: 414.664,
    rx: 9.295,
    ry: 16.738
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrawberry);
export default __webpack_public_path__ + "static/media/strawberry.56b3a6b07d459b52819d9e42c5906220.svg";
export { ForwardRef as ReactComponent };